import { useEffect, useState } from 'react'

const BEAMER_ANNOUNCEMENT_BAR_ID = 'beamerAnnouncementBar'

const readBeamerBarHeight = () =>
  document.getElementById(BEAMER_ANNOUNCEMENT_BAR_ID)?.getBoundingClientRect()
    .height || 0

// Beamer's script injects (and can later remove/resize) #beamerAnnouncementBar
// asynchronously - on a fresh page load/refresh it usually isn't in the DOM
// yet by the time consumers first render. Watch for it instead of reading its
// height once, so height-dependent layouts stay in sync once it appears.
export const useBeamerBarHeight = () => {
  const [height, setHeight] = useState(readBeamerBarHeight)

  useEffect(() => {
    const resizeObserver =
      typeof ResizeObserver !== 'undefined' ? new ResizeObserver(sync) : null

    function sync() {
      setHeight(readBeamerBarHeight())

      const bar = document.getElementById(BEAMER_ANNOUNCEMENT_BAR_ID)
      if (bar) {
        resizeObserver?.observe(bar)
      }
    }

    const mutationObserver = new MutationObserver(sync)
    mutationObserver.observe(document.body, {
      childList: true,
      subtree: true
    })

    sync()

    return () => {
      mutationObserver.disconnect()
      resizeObserver?.disconnect()
    }
  }, [])

  return height
}
